export function useSurfaceEditorStoreContextMenu({surfaces, selectElement}) {
  const surfaceEditorUtils = useSurfaceEditorUtils();

  const contextMenuState = ref({
    isOpen: false,
    x: 0,
    y: 0,
    elementId: null,
    surfaceId: null
  });

  const contextMenuElement = computed(() => {
    if (!contextMenuState.value.elementId) return null;

    return surfaceEditorUtils.findElementInSurface({
      elementId: contextMenuState.value.elementId,
      surfaces: surfaces.value
    });
  });

  function openContextMenu({element, x, y}) {
    if (!element || element.background) return;

    const context = surfaceEditorUtils.findElementInSurface({
      elementId: element.id,
      surfaces: surfaces.value
    });

    if (!context?.element) return;

    selectElement({element: context.element});

    contextMenuState.value = {
      isOpen: true,
      x,
      y,
      elementId: context.element.id,
      surfaceId: context.surface.id
    };
  }

  function closeContextMenu() {
    contextMenuState.value = {
      isOpen: false,
      x: 0,
      y: 0,
      elementId: null,
      surfaceId: null
    };
  }

  return {
    contextMenuState,
    contextMenuElement,
    openContextMenu,
    closeContextMenu
  };
}
